import styled from "styled-components";

export const ImageGridWrapperDiv = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-x: hidden;
`;

export const ImageGridItemsContainerDiv = styled.div`
    align-items: center;
    display: grid;
    grid-gap: 16px;
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
    justify-items: center;
`;
